import { CoreModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, effect, inject, model } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DwApiSelectDirective } from '@digiwall/core';
import { TextTemplateLookupDto, TextTemplateService, TextTemplateType } from '@digiwall/core/proxy';
import { DocRole } from '@digiwall/goliath-core/proxy';
import {
  DayBookDto,
  DayBookService,
  DocPrintTemplateLookupRequestDto,
  DocPrintTemplateService,
} from '@digiwall/goliath-documents/proxy';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'document-invoicing-configuration',
  templateUrl: './invoicing-configuration.component.html',
  imports: [CommonModule, ReactiveFormsModule, CoreModule, NgSelectModule, DwApiSelectDirective],
})
export class InvoicingConfigurationComponent {
  protected readonly daybookService = inject(DayBookService);
  protected readonly printTemplateService = inject(DocPrintTemplateService);
  protected readonly textTemplateService = inject(TextTemplateService);

  protected generateInvoice = model<boolean>(false);
  protected invoicingDaybookId = model<string>(null);
  protected invoicingPrintTemplateId = model<string>(null);
  protected sendInvoice = model<boolean>(false);
  protected invoiceEmailTemplateId = model<string>(null);

  protected dayBooks: DayBookDto[] = [];
  protected textTemplates: TextTemplateLookupDto[] = [];

  constructor() {
    this.daybookService
      .getDayBooksByRole(DocRole.CustomerInvoice)
      .subscribeOnce(daybooks => (this.dayBooks = daybooks));

    this.textTemplateService
      .getTemplateNamesList(TextTemplateType.Email, DocRole.CustomerInvoice)
      .subscribeOnce(templates => (this.textTemplates = templates));

    effect(() => {
      const generateInvoice = this.generateInvoice();
      if (generateInvoice) {
        if (this.dayBooks?.length > 0) {
          this.invoicingDaybookId.set(this.dayBooks[0].id);
          this.invoicingPrintTemplateId.set(this.dayBooks[0].docPrintTemplateId);
        }
      } else {
        this.invoicingDaybookId.set(null);
        this.invoicingPrintTemplateId.set(null);
        this.sendInvoice.set(false);
      }
    });

    effect(() => {
      const sendInvoice = this.sendInvoice();
      if (sendInvoice) {
        if (this.textTemplates?.length > 0) {
          this.invoiceEmailTemplateId.set(this.textTemplates[0].id);
        }
      } else {
        this.invoiceEmailTemplateId.set(null);
      }
    });
  }

  protected printTemplateSelect = (dto: DocPrintTemplateLookupRequestDto) => {
    dto.sorting = [{ property: 'name' }];
    dto.queryProperties = ['name'];
    dto.docRole = DocRole.CustomerInvoice;
    return this.printTemplateService.getLookupList(dto);
  };
}
